import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
      <p className="font-heading text-6xl font-black text-background-300 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个瓜好像被人抢走了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        页面 <span className="rounded bg-background-100 px-1.5 py-0.5 text-foreground-800">{location.pathname}</span> 暂时找不到。
        也许是链接过期了，回到首页看看吧，那里每天都有新的内容。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          回到首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览全部瓜料
        </Link>
      </div>
    </div>
  );
}